import { render, staticRenderFns } from "./Neighborhoods.container.vue?vue&type=template&id=b1c449d6&"
import script from "./Neighborhoods.container.vue?vue&type=script&lang=ts&"
export * from "./Neighborhoods.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports